webpackJsonp([93],{

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      instructionGroups: []
    };
  },

  methods: {
    loadGroups: function loadGroups() {
      var _this = this;

      request.page('queryTrainingInstructionGroupAll').then(function (_ref) {
        var data = _ref.data;

        _this.instructionGroups = data.map(function (it) {
          return { value: it.id, label: it.name };
        });
      });
    },
    deleteInstructionGroup: function deleteInstructionGroup(item) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5220\u9664\u5206\u7EC4\u300C' + item.label + '\u300D\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        return request.common('deleteTrainingInstructionGroup', item.value);
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.onInstructionGroupDeleted(item);
        _this2.loadGroups();
      }).catch(function () {});
    },
    onInstructionGroupDeleted: function onInstructionGroupDeleted(item) {
      if (this.form && this.form.instruction_group_name === item.label) {
        this.form.instruction_group_name = null;
      }
      if (this.search && Number(this.search.instruction_group_id) === Number(item.value)) {
        this.search.instruction_group_id = null;
      }
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    }
  }
});

/***/ }),

/***/ 1669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COURSE_FILE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["k"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* harmony export (immutable) */ __webpack_exports__["i"] = getFileExtension;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseFileTypeByFile;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["m"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);





var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  INTERN_SCOPE_ALL: 1, // 全部实习生
  INTERN_SCOPE_SPECIFIC: 2, // 指定实习生

  KNOWLEDGE_STATUS_ACTIVE: 2
};

var COURSE_FILE_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf',
  PPT: 'ppt',
  WORD: 'word',
  EXCEL: 'excel'
};

var opts = {
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }],
  InternScopeMaps: [{ value: consts.INTERN_SCOPE_ALL, label: '全部' }, { value: consts.INTERN_SCOPE_SPECIFIC, label: '指定' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineInternTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banInternTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeInternTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  label: '图片'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 0,
  maxSizeMB: 1024,
  label: '视频'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PDF, {
  accept: ['application/pdf'],
  extensions: ['pdf'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PDF'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.PPT, {
  accept: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  extensions: ['ppt', 'pptx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'PPT'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.WORD, {
  accept: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  extensions: ['doc', 'docx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Word'
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, COURSE_FILE_TYPES.EXCEL, {
  accept: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  extensions: ['xls', 'xlsx'],
  maxFiles: 0,
  maxSizeMB: 100,
  label: 'Excel'
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseFileTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0) {
    return COURSE_FILE_TYPES.IMAGE;
  }
  if (type.indexOf('video/') === 0) {
    return COURSE_FILE_TYPES.VIDEO;
  }
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_FILE_TYPES).some(function (key) {
    return COURSE_FILE_TYPES[key] === type;
  })) {
    return type;
  }

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).find(function (fileType) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    return config.accept.includes(type) || config.extensions.includes(ext);
  }) || '';
}

function getCourseUploadConfig(fileType) {
  if (fileType && COURSE_UPLOAD_TYPE_CONFIGS[fileType]) {
    var config = COURSE_UPLOAD_TYPE_CONFIGS[fileType];
    var maxSizeLabel = config.maxSizeMB >= 1024 ? (config.maxSizeMB / 1024).toFixed(config.maxSizeMB % 1024 === 0 ? 0 : 1) + 'GB' : config.maxSizeMB + 'MB';
    var maxFilesLabel = config.maxFiles > 0 ? '\u6700\u591A ' + config.maxFiles + ' \u4E2A' : '可上传多个';

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, {
      tip: '\u652F\u6301\u4E0A\u4F20' + config.label + '\uFF0C' + maxFilesLabel + '\uFF0C\u5355\u4E2A\u6700\u5927 ' + maxSizeLabel
    });
  }

  var configs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
    return COURSE_UPLOAD_TYPE_CONFIGS[type];
  });
  return {
    accept: configs.reduce(function (result, item) {
      return result.concat(item.accept);
    }, []),
    extensions: configs.reduce(function (result, item) {
      return result.concat(item.extensions);
    }, []),
    maxFiles: 0,
    maxSizeMB: Math.max.apply(null, configs.map(function (item) {
      return item.maxSizeMB;
    })),
    tip: '支持图片、视频、PDF、PPT、Word、Excel，可上传多个文件，单个文件大小按类型限制'
  };
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var fileType = getCourseFileTypeByFile(file);
  if (!fileType) {
    return {
      valid: false,
      fileType: fileType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(fileType);
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  var currentTypeCount = Array.isArray(currentFiles) ? currentFiles.filter(function (item) {
    return getCourseFileTypeByFile(item) === fileType;
  }).length : 0;
  if (config.maxFiles > 0 && currentTypeCount >= config.maxFiles) {
    return {
      valid: false,
      fileType: fileType,
      message: config.tip,
      replaceAll: false
    };
  }

  return {
    valid: true,
    fileType: fileType,
    message: '',
    replaceAll: false
  };
}

/***/ }),

/***/ 3055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function createCourseJsonValidator() {
  return function (rule, value, callback) {
    if (!Array.isArray(value) || value.length < 1) {
      callback(new Error('请上传教程内容'));
      return;
    }

    var fileCounts = value.reduce(function (counts, file) {
      var fileType = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file);
      if (fileType) {
        counts[fileType] = (counts[fileType] || 0) + 1;
      }
      return counts;
    }, {});
    // 判断数量
    var exceededType = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(fileCounts).find(function (fileType) {
      var config = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["h" /* getCourseUploadConfig */])(fileType);
      return config.maxFiles > 0 && fileCounts[fileType] > config.maxFiles;
    });
    if (exceededType) {
      callback(new Error(Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["h" /* getCourseUploadConfig */])(exceededType).tip));
      return;
    }
    callback();
  };
}

function createCustomerValidator(vm) {
  return function (rule, value, callback) {
    if (Number(vm.form.is_common) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */].IS_COMMON_DEDICATED && !value) {
      callback(new Error('请选择所属客户'));
      return;
    }
    callback();
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__views_training_training_mixins__["a" /* default */]],
  props: {
    signedUrlApiName: {
      type: String,
      default: 'getTrainingSignedOssUrl'
    }
  },
  data: function data() {
    return {
      id: 0,
      submitting: false,
      uploading: false,
      consts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */],
      opts: __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["l" /* opts */],
      form: {
        title: '',
        is_common: __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */].IS_COMMON_DEDICATED,
        customerid: null,
        training_knowledge_id: null,
        course_json: [],
        status: __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */].STATUS_NEW
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    loginUser: function loginUser(state) {
      return state.login.user || {};
    }
  }), {
    formRules: function formRules() {
      return {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }, { max: 100, message: '标题最多 100 个字符', trigger: 'blur' }],
        target_usertype: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        is_common: [{ required: true, message: '请选择是否通用', trigger: 'change' }],
        customerid: [{ validator: createCustomerValidator(this), trigger: 'change' }],
        training_knowledge_id: [{ required: true, message: '请选择所属知识库', trigger: 'change' }],
        course_json: [{ validator: createCourseJsonValidator(), trigger: 'change' }]
      };
    },
    uploadConfig: function uploadConfig() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["h" /* getCourseUploadConfig */])();
    },
    uploadAcceptText: function uploadAcceptText() {
      return this.uploadConfig.accept.concat(this.uploadConfig.extensions.map(function (ext) {
        return '.' + ext;
      })).join(',');
    },
    isRelationEditLocked: function isRelationEditLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["k" /* isCourseRelationEditLocked */])(this.id, this.form.status);
    },
    knowledgeQueryParams: function knowledgeQueryParams() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["b" /* buildCourseKnowledgeQueryParams */])({
        is_common: this.form.is_common,
        customerid: this.form.customerid
      });
    },
    knowledgeDisabled: function knowledgeDisabled() {
      return this.isRelationEditLocked || Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */].IS_COMMON_DEDICATED && !this.form.customerid;
    },
    imagePreviewList: function imagePreviewList() {
      var _this = this;

      return this.form.course_json.filter(function (file) {
        return _this.isImageFile(file);
      }).map(function (file) {
        return file.url;
      }).filter(Boolean);
    }
  }),
  created: function created() {
    this.onLoad();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'queryTrainingKnowledge', 'getTrainingKnowledge', 'getInternTrainingCourse', 'createInternTrainingCourse', 'updateInternTrainingCourse', 'getTrainingSignedOssUrl']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.id = Number(this.$route.params.id);
        this.loadDetail(this.id);
      }
    },
    loadDetail: function loadDetail(id) {
      var _this2 = this;

      request.page('getInternTrainingCourse', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this2.form.title = data.title || '';
        _this2.form.is_common = Number(data.is_common);
        _this2.form.id = Number(data.id);
        // 兼容客户字段回显问题
        _this2.form.customerid = Number(data.customerid) > 0 ? String(data.customerid) : null;
        _this2.form.training_knowledge_id = Number(data.training_knowledge_id) || null;
        _this2.form.course_json = Array.isArray(data.course_json) ? data.course_json.map(function (file) {
          return _this2.normalizeCourseFile(file);
        }) : [];
        _this2.form.status = Number(data.status) || __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */].STATUS_NEW;
      });
    },
    onIsCommonChanged: function onIsCommonChanged(value) {
      // 编辑上架或下架教程
      if (this.isRelationEditLocked) {
        return;
      }
      if (Number(value) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */].IS_COMMON_SHARED) {
        this.form.customerid = null;
      }
      this.form.training_knowledge_id = null;
      // 切换的时候清一下表单的验证
      this.clearCustomerValidate();
    },
    onCustomerChanged: function onCustomerChanged() {
      if (this.isRelationEditLocked) {
        return;
      }
      this.form.training_knowledge_id = null;
    },
    clearUploadCache: function clearUploadCache() {
      if (this.$refs.contentUpload) {
        this.$refs.contentUpload.clearFiles();
      }
    },
    clearCustomerValidate: function clearCustomerValidate() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs.form) {
          _this3.$refs.form.clearValidate(['customerid', 'training_knowledge_id']);
        }
      });
    },
    onCourseFileChange: function onCourseFileChange(file) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var raw, validation, loading, uploadedFile;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                raw = file.raw;

                if (raw) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                validation = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["m" /* validateCourseUploadFile */])(raw, _this4.form.course_json);

                if (validation.valid) {
                  _context.next = 8;
                  break;
                }

                _this4.$message.error(validation.message);
                _this4.clearUploadCache();
                return _context.abrupt('return');

              case 8:

                _this4.uploading = true;
                loading = _this4.$loading({
                  lock: true
                });
                _context.prev = 10;
                _context.next = 13;
                return _this4.uploadCourseFile(raw, _this4.signedUrlApiName);

              case 13:
                uploadedFile = _context.sent;

                if (validation.replaceAll) {
                  _this4.form.course_json = [uploadedFile];
                } else {
                  _this4.form.course_json.push(uploadedFile);
                }
                _this4.$message.success(validation.replaceAll ? '文件已替换' : '上传成功');
                _this4.$refs.form && _this4.$refs.form.validateField('course_json');
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](10);

                _this4.$message.error(_context.t0.message || '上传失败');

              case 22:
                _context.prev = 22;

                _this4.uploading = false;
                loading.close();
                _this4.clearUploadCache();
                return _context.finish(22);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[10, 19, 22, 27]]);
      }))();
    },
    uploadCourseFile: function uploadCourseFile(file, apiName) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var ext, _ref2, data, uploadRes;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ext = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["i" /* getFileExtension */])(file.name);
                _context2.next = 3;
                return request.common(apiName, {
                  file_name: file.name,
                  ext: ext,
                  content_type: file.type || 'application/octet-stream'
                });

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;
                _context2.next = 7;
                return fetch(data.signedUrl, {
                  method: 'PUT',
                  headers: new Headers({
                    'Content-Type': data.content_type
                  }),
                  body: file
                });

              case 7:
                uploadRes = _context2.sent;

                if (uploadRes.ok) {
                  _context2.next = 10;
                  break;
                }

                throw new Error('\u4E0A\u4F20\u5931\u8D25: ' + uploadRes.status);

              case 10:
                return _context2.abrupt('return', _this5.formatStandardFile({
                  name: file.name,
                  url: data.url,
                  uid: Date.now() + Math.random(),
                  size: file.size,
                  file_type: Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file),
                  mime_type: file.type || 'application/octet-stream'
                }, _this5.loginUser));

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },


    // 附件上传,标准化字段结构
    formatStandardFile: function formatStandardFile(file, loginUser) {
      var fileType = file.file_type || Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file);
      return {
        submit_admin_id: loginUser.id,
        submit_admin_name: loginUser.name,
        submit_at: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        name: file.name,
        size: file.size,
        url: file.url,
        uid: file.uid,
        type: fileType,
        mime_type: file.mime_type || '',
        extension: Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["i" /* getFileExtension */])(file.name)
      };
    },
    normalizeCourseFile: function normalizeCourseFile(file) {
      var fileType = Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file);
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, file, {
        type: fileType || file.type || '',
        mime_type: file.mime_type || (typeof file.type === 'string' && file.type.indexOf('/') !== -1 ? file.type : ''),
        extension: file.extension || Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["i" /* getFileExtension */])(file.name)
      });
    },
    isImageFile: function isImageFile(file) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].IMAGE;
    },
    getFileTypeLabel: function getFileTypeLabel(file) {
      var _labels;

      var labels = (_labels = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_labels, __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].IMAGE, '图片'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_labels, __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].VIDEO, '视频'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_labels, __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].PDF, 'PDF'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_labels, __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].PPT, 'PPT'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_labels, __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].WORD, 'Word'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_labels, __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].EXCEL, 'Excel'), _labels);
      return labels[Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file)] || '文件';
    },
    getFileIconClass: function getFileIconClass(file) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["d" /* getCourseFileTypeByFile */])(file) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["a" /* COURSE_FILE_TYPES */].VIDEO ? 'el-icon-video-camera' : 'el-icon-document';
    },
    removeCourseFile: function removeCourseFile(index) {
      this.form.course_json.splice(index, 1);
      this.$refs.form && this.$refs.form.validateField('course_json');
    },
    openFile: function openFile(file) {
      if (!file || !file.url) {
        return;
      }
      window.open(file.url, '_blank');
    },
    formatFileSize: function formatFileSize(size) {
      var value = Number(size) || 0;
      if (value >= 1024 * 1024) {
        return (value / 1024 / 1024).toFixed(2) + 'MB';
      }
      if (value >= 1024) {
        return (value / 1024).toFixed(2) + 'KB';
      }
      return value + 'B';
    },
    getSubmitPayload: function getSubmitPayload() {
      var payload = filter.copyJson(this.form);
      if (Number(payload.is_common) === __WEBPACK_IMPORTED_MODULE_6__views_training_training_course_intern_constants__["c" /* consts */].IS_COMMON_SHARED) {
        payload.customerid = 0;
      }
      delete payload.status;
      return payload;
    },
    onSubmit: function onSubmit() {
      var _this6 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this6.$message.error('请检查表单填写是否正确');
          return;
        }
        _this6.submitting = true;
        var requestName = _this6.id ? 'updateInternTrainingCourse' : 'createInternTrainingCourse';
        var params = _this6.id ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: _this6.id }, _this6.getSubmitPayload()) : _this6.getSubmitPayload();
        request.common(requestName, params).then(function () {
          _this6.$message.success(_this6.id ? '保存成功' : '创建成功');
          _this6.$router.push({ path: '/training/intern-course' });
        }).finally(function () {
          _this6.submitting = false;
        });
      });
    }
  })
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternTrainingCourseForm_vue__ = __webpack_require__(3055);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91766fd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternTrainingCourseForm_vue__ = __webpack_require__(5666);
function injectStyle (ssrContext) {
  __webpack_require__(5664)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91766fd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternTrainingCourseForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91766fd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternTrainingCourseForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5664:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("43592758", content, true, {});

/***/ }),

/***/ 5665:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".form-item-full[data-v-91766fd0],.upload-panel[data-v-91766fd0]{width:100%}.upload-panel__dropzone[data-v-91766fd0]{width:100%;max-width:760px}.upload-panel__dropzone[data-v-91766fd0] .el-upload,.upload-panel__dropzone[data-v-91766fd0] .el-upload-dragger{width:100%}.upload-panel__dropzone[data-v-91766fd0] .el-upload-dragger{height:auto;min-height:160px;padding:48px 32px;border:1px dashed #8cc5ff;border-radius:6px;background:#f8fbff}.upload-panel__dropzone[data-v-91766fd0] .el-upload-dragger:hover{border-color:#409eff}.upload-panel__icon[data-v-91766fd0]{font-size:44px;color:#409eff;margin-bottom:12px}.upload-panel__text[data-v-91766fd0]{font-size:14px;color:#606266;line-height:22px}.upload-panel__text em[data-v-91766fd0]{font-style:normal;color:#409eff}.upload-panel__tip[data-v-91766fd0]{margin-top:12px;line-height:20px;color:#909399}.upload-list[data-v-91766fd0]{margin-top:16px;max-width:960px}.course-file-item+.course-file-item[data-v-91766fd0]{margin-top:8px}.image-list[data-v-91766fd0]{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:16px}.image-item[data-v-91766fd0]{max-width:300px;border:1px solid #d9ecff;border-radius:6px;padding:10px;background:#f8fbff}.image-item__thumb[data-v-91766fd0]{width:100%;height:100px;border-radius:4px;background:#f5f7fa}.image-item__name[data-v-91766fd0]{margin-top:8px;font-size:12px;line-height:18px;color:#303133;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.image-item__actions[data-v-91766fd0]{margin-top:4px}.file-row[data-v-91766fd0],.image-item__actions[data-v-91766fd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.file-row[data-v-91766fd0]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:12px;border:1px solid #d9ecff;border-radius:6px;background:#f8fbff}.file-row+.file-row[data-v-91766fd0]{margin-top:8px}.file-row__meta[data-v-91766fd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;min-width:0}.file-row__icon[data-v-91766fd0]{width:36px;height:36px;-ms-flex-negative:0;flex-shrink:0;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:18px;background:#ecf5ff}.file-row__icon i[data-v-91766fd0]{font-size:24px;color:#409eff}.file-row__text[data-v-91766fd0]{min-width:0}.file-row__name[data-v-91766fd0]{font-size:13px;color:#303133;line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-row__desc[data-v-91766fd0]{margin-top:2px;font-size:12px;line-height:18px;color:#909399}.file-row__actions[data-v-91766fd0]{-ms-flex-negative:0;flex-shrink:0}.form-actions[data-v-91766fd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:28px}.form-actions .el-button+.el-button[data-v-91766fd0]{margin-left:12px}.content-lock-alert[data-v-91766fd0]{margin-bottom:16px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/course/InternTrainingCourseForm.vue"],"names":[],"mappings":"AAGA,gEAA+B,UAAU,CACxC,AACD,yCAAyC,WAAW,eAAe,CAClE,AACD,gHAAgH,UAAU,CACzH,AACD,4DAA4D,YAAY,iBAAiB,kBAAkB,0BAA0B,kBAAkB,kBAAkB,CACxK,AACD,kEAAkE,oBAAoB,CACrF,AACD,qCAAqC,eAAe,cAAc,kBAAkB,CACnF,AACD,qCAAqC,eAAe,cAAc,gBAAgB,CACjF,AACD,wCAAwC,kBAAkB,aAAa,CACtE,AACD,oCAAoC,gBAAgB,iBAAiB,aAAa,CACjF,AACD,8BAA8B,gBAAgB,eAAe,CAC5D,AACD,qDAAqD,cAAc,CAClE,AACD,6BAA6B,aAAa,0DAA4D,QAAQ,CAC7G,AACD,6BAA6B,gBAAgB,yBAAyB,kBAAkB,aAAa,kBAAkB,CACtH,AACD,oCAAoC,WAAW,aAAa,kBAAkB,kBAAkB,CAC/F,AACD,mCAAmC,eAAe,eAAe,iBAAiB,cAAc,mBAAmB,gBAAgB,sBAAsB,CACxJ,AACD,sCAAwK,cAAc,CACrL,AACD,iEAFsC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,6BAA8B,CAGvK,AADD,2BAAgF,yBAAyB,sBAAsB,mBAAmB,AAA6E,SAAS,aAAa,yBAAyB,kBAAkB,kBAAkB,CACjT,AACD,qCAAqC,cAAc,CAClD,AACD,iCAAiC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,WAAW,CAC3K,AACD,iCAAiC,WAAW,YAAY,oBAAoB,cAAc,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,mBAAmB,kBAAkB,CAC9U,AACD,mCAAmC,eAAe,aAAa,CAC9D,AACD,iCAAiC,WAAW,CAC3C,AACD,iCAAiC,eAAe,cAAc,iBAAiB,mBAAmB,gBAAgB,sBAAsB,CACvI,AACD,iCAAiC,eAAe,eAAe,iBAAiB,aAAa,CAC5F,AACD,oCAAoC,oBAAoB,aAAa,CACpE,AACD,+BAA+B,oBAAoB,oBAAoB,aAAa,qBAAqB,kBAAkB,yBAAyB,eAAe,CAClK,AACD,qDAAqD,gBAAgB,CACpE,AACD,qCAAqC,kBAAkB,CACtD","file":"InternTrainingCourseForm.vue","sourcesContent":["\n.form-item-full[data-v-91766fd0]{width:100%\n}\n.upload-panel[data-v-91766fd0]{width:100%\n}\n.upload-panel__dropzone[data-v-91766fd0]{width:100%;max-width:760px\n}\n.upload-panel__dropzone[data-v-91766fd0] .el-upload,.upload-panel__dropzone[data-v-91766fd0] .el-upload-dragger{width:100%\n}\n.upload-panel__dropzone[data-v-91766fd0] .el-upload-dragger{height:auto;min-height:160px;padding:48px 32px;border:1px dashed #8cc5ff;border-radius:6px;background:#f8fbff\n}\n.upload-panel__dropzone[data-v-91766fd0] .el-upload-dragger:hover{border-color:#409EFF\n}\n.upload-panel__icon[data-v-91766fd0]{font-size:44px;color:#409EFF;margin-bottom:12px\n}\n.upload-panel__text[data-v-91766fd0]{font-size:14px;color:#606266;line-height:22px\n}\n.upload-panel__text em[data-v-91766fd0]{font-style:normal;color:#409EFF\n}\n.upload-panel__tip[data-v-91766fd0]{margin-top:12px;line-height:20px;color:#909399\n}\n.upload-list[data-v-91766fd0]{margin-top:16px;max-width:960px\n}\n.course-file-item+.course-file-item[data-v-91766fd0]{margin-top:8px\n}\n.image-list[data-v-91766fd0]{display:grid;grid-template-columns:repeat(auto-fill, minmax(300px, 1fr));gap:16px\n}\n.image-item[data-v-91766fd0]{max-width:300px;border:1px solid #d9ecff;border-radius:6px;padding:10px;background:#f8fbff\n}\n.image-item__thumb[data-v-91766fd0]{width:100%;height:100px;border-radius:4px;background:#f5f7fa\n}\n.image-item__name[data-v-91766fd0]{margin-top:8px;font-size:12px;line-height:18px;color:#303133;white-space:nowrap;overflow:hidden;text-overflow:ellipsis\n}\n.image-item__actions[data-v-91766fd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:4px\n}\n.file-row[data-v-91766fd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;padding:12px;border:1px solid #d9ecff;border-radius:6px;background:#f8fbff\n}\n.file-row+.file-row[data-v-91766fd0]{margin-top:8px\n}\n.file-row__meta[data-v-91766fd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;min-width:0\n}\n.file-row__icon[data-v-91766fd0]{width:36px;height:36px;-ms-flex-negative:0;flex-shrink:0;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:18px;background:#ecf5ff\n}\n.file-row__icon i[data-v-91766fd0]{font-size:24px;color:#409EFF\n}\n.file-row__text[data-v-91766fd0]{min-width:0\n}\n.file-row__name[data-v-91766fd0]{font-size:13px;color:#303133;line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis\n}\n.file-row__desc[data-v-91766fd0]{margin-top:2px;font-size:12px;line-height:18px;color:#909399\n}\n.file-row__actions[data-v-91766fd0]{-ms-flex-negative:0;flex-shrink:0\n}\n.form-actions[data-v-91766fd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:28px\n}\n.form-actions .el-button+.el-button[data-v-91766fd0]{margin-left:12px\n}\n.content-lock-alert[data-v-91766fd0]{margin-bottom:16px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/intern-course' }}},[_vm._v("实习生教程管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px","label-position":"left"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('layout-panel',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("表单")]},proxy:true}])},[_vm._v(" "),(_vm.isRelationEditLocked)?_c('el-alert',{staticClass:"content-lock-alert",attrs:{"type":"info","closable":false,"show-icon":"","title":"当前教程已上架或已下架，仅可修改标题、上传内容"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{staticClass:"form-item-full",attrs:{"label":"标题","prop":"title"}},[_c('el-input',{attrs:{"clearable":"","maxlength":"100","show-word-limit":"","placeholder":"请输入教程标题"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传内容","prop":"course_json"}},[_c('div',{staticClass:"upload-panel"},[_c('el-upload',{ref:"contentUpload",staticClass:"upload-panel__dropzone",attrs:{"drag":"","action":"","auto-upload":false,"show-file-list":false,"multiple":true,"accept":_vm.uploadAcceptText,"disabled":_vm.uploading,"on-change":_vm.onCourseFileChange}},[_c('i',{staticClass:"el-icon-upload upload-panel__icon"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text upload-panel__text"},[_vm._v("\n                将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip upload-panel__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n                "+_vm._s(_vm.uploadConfig.tip)+"\n              ")])]),_vm._v(" "),(_vm.form.course_json.length)?_c('div',{staticClass:"upload-list"},_vm._l((_vm.form.course_json),function(file,index){return _c('div',{key:file.uid || file.url || index,staticClass:"course-file-item"},[(_vm.isImageFile(file))?_c('div',{staticClass:"image-item"},[_c('el-image',{staticClass:"image-item__thumb",attrs:{"src":file.url,"preview-src-list":_vm.imagePreviewList,"fit":"cover"}}),_vm._v(" "),_c('div',{staticClass:"image-item__name",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('div',{staticClass:"image-item__actions"},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.openFile(file)}}},[_vm._v("查看")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.removeCourseFile(index)}}},[_vm._v("删除")])],1)],1):_c('div',{staticClass:"file-row"},[_c('div',{staticClass:"file-row__meta"},[_c('div',{staticClass:"file-row__icon"},[_c('i',{class:_vm.getFileIconClass(file)})]),_vm._v(" "),_c('div',{staticClass:"file-row__text"},[_c('div',{staticClass:"file-row__name",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('div',{staticClass:"file-row__desc"},[_vm._v("\n                        "+_vm._s(_vm.getFileTypeLabel(file))+" / "+_vm._s(_vm.formatFileSize(file.size))+"\n                        "),(file.submit_admin_name)?_c('span',[_vm._v(" / "+_vm._s(file.submit_admin_name))]):_vm._e(),_vm._v(" "),(file.submit_at)?_c('span',[_vm._v(" / "+_vm._s(file.submit_at))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"file-row__actions"},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.openFile(file)}}},[_vm._v("查看")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.removeCourseFile(index)}}},[_vm._v("删除")])],1)])])}),0):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isRelationEditLocked},on:{"change":_vm.onIsCommonChanged},model:{value:(_vm.form.is_common),callback:function ($$v) {_vm.$set(_vm.form, "is_common", $$v)},expression:"form.is_common"}},_vm._l((_vm.opts.isCommonMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v("\n              "+_vm._s(item.label)+"\n            ")])}),1)],1),_vm._v(" "),(Number(_vm.form.is_common) === _vm.consts.IS_COMMON_DEDICATED)?_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请输入客户名称/编号搜索","disabled":_vm.isRelationEditLocked,"query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},on:{"change":_vm.onCustomerChanged},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入知识库名称搜索","disabled":_vm.knowledgeDisabled,"query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge,"query-params":_vm.knowledgeQueryParams},model:{value:(_vm.form.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.form, "training_knowledge_id", $$v)},expression:"form.training_knowledge_id"}})],1),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","native-type":"submit","loading":_vm.submitting || _vm.uploading}},[_vm._v("\n            保存教程\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/intern-training-course-form.cd9188aa7af28a5ba88f.js